import { _ } from '/@/locale';
import { isPhone, isUserValidatedRV, openWhatsappWeb } from '/@/utils';
import { openPrivacyPolicy } from '../components/new-login/login';
import settings from '../core/settings';
import { mpTrackEvent } from '../store/tracking/mixpanel-events';

const getFullMenu = (isUserValidated: boolean) => {
    let menu;
    if (settings.app.theme === 'expertobayer') {
        menu = [
            {
                label: _('Inicio'),
                view: 'NewHome',
                disableOffline: true,
                selectedFeature: 'NewHome',
            },
            {
                label: _('Recomendaciones'),
                disableOffline: true,
                sessionFlag: 'cornRecommendationEnabled',
                children: [
                    {
                        label: _('Mis Recomendaciones'),
                        view: 'MyRecommendations',
                        disableOffline: true,
                        selectedFeature: 'my-recommendations',
                    },
                    {
                        label: _('Recomendaciones N-Smart'),
                        view: 'nitrogenRecommendation.NitrogenRecommendationList',
                        disableOffline: true,
                        selectedFeature: 'nitrogenrecommendationlist.nitrogen',
                        sessionFlag: 'nitrogenRecommendationEnabled',
                    },
                ],
            },
            {
                label: _('Mis seguimientos'),
                view: 'cropMonitoring.CropMonitoring',
                disableOffline: true,
                selectedFeature: 'cropMonitoring',
                sessionFlag: 'cropMonitoringEnabled',
            },
            ...(isUserValidated
                ? [
                      {
                          label: _('Productos'),
                          view: 'productExploration.main',
                          disableOffline: true,
                          selectedFeature: '',
                          sessionFlag: '',
                          featureFlag: 'enableRvCustomHome',
                          RVOnly: true,
                      },
                  ]
                : []),
            {
                label: _('Herramientas'),
                disableOffline: false,
                children: [
                    {
                        label: _('Calidad de Semilla Maíz'),
                        view: 'BagQuality',
                        selectedFeature: 'BagQuality',
                        disableOffline: true,
                        sessionFlag: 'bagQualityEnabled',
                    },
                    {
                        label: _('Buscador de malezas'),
                        view: 'WeedFinder',
                        disableOffline: true,
                        selectedFeature: 'weedFinder',
                        sessionFlag: 'enableWeedsFinder',
                    },
                    {
                        label: _('Red de ensayos'),
                        view: 'FieldTrialNetwork',
                        selectedFeature: 'FieldTrialNetwork',
                        disableOffline: true,
                        sessionFlag: 'fieldTrialNetworkEnabled',
                    },
                ],
            },
            {
                label: _('Soporte y ayuda'),
                disableOffline: false,
                children: [
                    {
                        label: _('Consulta a un experto'),
                        view: 'AskAnExpert',
                        disableOffline: true,
                        selectedFeature: 'open',
                        sessionFlag: 'enableAskAnExpert',
                        onClick: (fallback, extraData) => {
                            if (extraData.country.code === 'BR') {
                                openWhatsappWeb({
                                    phone: '+5511997535194',
                                });
                            } else {
                                fallback('AskAnExpert', 'open', null);
                            }
                        },
                    },
                    {
                        label: _('Ayuda'),
                        view: 'helpCenter.Home',
                        disableOffline: true,
                        selectedFeature: 'helpcenter.home',
                    },
                    {
                        label: _('Términos y condiciones'),
                        view: 'NewHome',
                        disableOffline: false,
                        selectedFeature: 'NewHome',
                        onClick: (fallback, extraData) => {
                            extraData.tcFallback();
                            fallback('NewHome', 'FieldDetail');
                        },
                    },
                    {
                        label: _('Política de privacidad'),
                        disableOffline: true,
                        selectedFeature: 'open',
                        onClick: openPrivacyPolicy,
                    },
                ],
            },
        ];
    } else {
        menu = [
            {
                label: _('Inicio'),
                view: 'NewHome',
                disableOffline: false,
                selectedFeature: 'NewHome',
            },
            {
                label: _('Mis lotes'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'FieldDetail',
            },
            {
                label: _('Crear un nuevo lote'),
                view: 'fields.NewField',
                disableOffline: true,
                selectedFeature: 'newfield.fielddetail',
            },
            {
                label: _('Recomendación de Maíz'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'recommendation',
                crop: 'corn',
                sessionFlag: 'cornRecommendationEnabled',
            },
            {
                label: _('Recomendación de Soja'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'recommendation',
                crop: 'soy',
                sessionFlag: 'soyRecommendationEnabled',
            },
            {
                label: _('Seguimiento de cultivo'),
                view: 'cropMonitoring.CropMonitoring',
                disableOffline: true,
                selectedFeature: 'cropMonitoring',
                sessionFlag: 'cropMonitoringEnabled',
            },
            {
                label: _('Mis Recomendaciones'),
                view: 'MyRecommendations',
                disableOffline: true,
                selectedFeature: 'my-recommendations',
            },
            {
                label: _('Manejo de Malezas'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'weeds',
                crop: 'corn',
                sessionFlag: 'weedsEnabled',
            },
            {
                label: _('Recomendaciones N-Smart'),
                view: 'nitrogenRecommendation.NitrogenRecommendationList',
                disableOffline: true,
                selectedFeature: 'nitrogenrecommendationlist.nitrogen',
                sessionFlag: 'nitrogenRecommendationEnabled',
            },
            {
                label: _('Calidad de Semilla Maíz'),
                view: 'BagQuality',
                disableOffline: true,
                sessionFlag: 'bagQualityEnabled',
            },
            {
                label: _('Head to Head Maíz'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'h2h',
                crop: 'corn',
                sessionFlag: 'enableCornHeadToHead',
                trackMethod: () => mpTrackEvent('H2H open', { entry_source: 'side-bar' }),
            },
            {
                label: _('Head to Head Soja'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'h2h',
                crop: 'soy',
                sessionFlag: 'enableSoyHeadToHead',
                trackMethod: () => mpTrackEvent('H2H open', { entry_source: 'side-bar' }),
            },
            {
                label: _('Simulador de rotaciones sustentables'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'carbonCalculator',
                sessionFlag: 'carbonCalculatorEnabled',
            },
            {
                label: _('Simulador de rotaciones sustentables'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'carbonCalculatorBR',
                sessionFlag: 'carbonCalculatorBREnabled',
            },
            {
                label: _('Buscador de malezas'),
                view: 'WeedFinder',
                disableOffline: true,
                selectedFeature: 'weedFinder',
                sessionFlag: 'enableWeedsFinder',
            },
            {
                label: _('Multiplicadores soja'),
                view: 'SoyMultipliers',
                disableOffline: true,
                selectedFeature: 'multipliers',
                sessionFlag: 'soyMultipliersEnabled',
            },
            {
                label: _('Mapas'),
                view: 'Map',
                disableOffline: true,
                selectedFeature: 'maps',
                sessionFlag: 'mapsEnabled',
                qs: { tab: 'overlays' },
                trackMethod: () => mpTrackEvent('Maps open', { entry_source: 'side-bar' }),
            },
            {
                label: _('Clima'),
                view: 'Home',
                disableOffline: true,
                selectedFeature: 'weather',
                sessionFlag: 'weatherEnabled',
                onClick: (fallback, _) => {
                    if (isPhone()) {
                        fallback('Home', 'weatherPhone', null);
                    } else {
                        fallback('Home', 'weather', null);
                    }
                },
            },
            {
                label: _('Red de ensayos'),
                view: 'FieldTrialNetwork',
                disableOffline: true,
                sessionFlag: 'fieldTrialNetworkEnabled',
            },
            {
                label: _('Ficha técnica de producto'),
                view: 'Home',
                disableOffline: true,
                sessionFlag: 'productDatasheetEnabled',
                selectedFeature: 'productDatasheet',
            },
            {
                label: _('Catálogo'),
                view: 'catalog.BrandSelection',
                disableOffline: true,
                selectedFeature: 'brandselection.catalog',
                sessionFlag: 'catalogEnabled',
            },
            {
                label: _('Riesgo de helada'),
                view: 'frost_risk',
                disableOffline: true,
                selectedFeature: 'frost_risk',
                sessionFlag: 'frostRiskEnabled',
            },
            {
                label: _('Biblioteca'),
                view: 'library.LibraryList',
                disableOffline: true,
                selectedFeature: 'librarylist.library',
                sessionFlag: 'libraryEnabled',
            },
            {
                label: _('Ayuda'),
                view: 'helpCenter.Home',
                disableOffline: true,
                selectedFeature: 'helpcenter.home',
            },
            {
                label: _('Consulta a un experto'),
                view: 'AskAnExpert',
                disableOffline: true,
                selectedFeature: 'open',
                sessionFlag: 'enableAskAnExpert',
                onClick: (fallback, extraData) => {
                    if (extraData.country.code === 'BR') {
                        openWhatsappWeb({
                            phone: '+5511997535194',
                        });
                    } else {
                        fallback('AskAnExpert', 'open', null);
                    }
                },
            },
            {
                label: _('Términos y condiciones'),
                view: 'NewHome',
                disableOffline: false,
                selectedFeature: 'open',
                onClick: (fallback, extraData) => {
                    extraData.tcFallback();
                    fallback('NewHome', 'open');
                },
            },
            {
                label: _('Política de privacidad'),
                disableOffline: true,
                selectedFeature: 'open',
                onClick: openPrivacyPolicy,
            },
        ];
    }
    return menu;
};

export const checkInternal = (user, appInstance) => {
    if (!user || !user.internalProfileEnabled) return false;
    return user.internalAppInstances.includes(appInstance.id);
};

const checkFeatureFlag = (appInstance, featureFlag) => appInstance[featureFlag];

// session = {appInstance, user, brands, maps, sessionFlags}
export const parseConfig = (session) => {
    const { brands, ...config } = session;
    config.availableBrandTypes = Object.keys(brands);
    config.publishedBrandTypes = config.availableBrandTypes.filter((type) => brands?.[type]?.some((b) => b.published));
    return config;
};

// config = {user, availableBrandTypes, publishedBrandTypes, sessionFlags}
export const checkItemDisplay = (item, config) => {
    const { brand, sessionFlag, internal, featureFlag } = item;
    if (brand && !config.availableBrandTypes.includes(brand.type)) return false;
    if (brand && brand.published && !config.publishedBrandTypes.includes(brand.type)) return false;
    if (sessionFlag && !config.sessionFlags[sessionFlag]) return false;
    if (internal && !checkInternal(config.user, config.appInstance)) return false;
    if (featureFlag && !checkFeatureFlag(config.appInstance, featureFlag)) return false;
    return true;
};

// config = {user, availableBrandTypes, publishedBrandTypes, sessionFlags}
const buildMenu = (items, item, config) => {
    if (!checkItemDisplay(item, config)) return items;
    let children = item.children && item.children.filter((child) => checkItemDisplay(child, config));
    if (children) children = children.reduce((items, item) => buildMenu(items, item, config), []);
    if (children && !children.length) return items;
    items.push({ ...item, children });
    return items;
};

// session = {appInstance, user, brands, maps, sessionFlags}
export const getMenuItems = (session) => {
    const isValidatedRV = isUserValidatedRV(session?.user);
    const menu = getFullMenu(isValidatedRV);
    const config = parseConfig(session);
    return menu.reduce((items, item) => buildMenu(items, item, config), []);
};
